import React from "react";
import "./Contactus.css";
import ContactForm from "../../Components/ContactForm";
import { useTranslation } from "react-i18next";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaHeadset,
  FaBolt,
  FaSmile,
  FaIdCard,
  FaUserShield,
  FaUser,
  FaFileMedical,
  FaFileAlt,
  FaImage
} from "react-icons/fa";

const Contactus = () => {
  const { t } = useTranslation();

  const admissionDocs = [
    { icon: <FaIdCard />, title: "contact.doc_aadhaar_p", desc: "contact.doc_aadhaar_p_sub" },
    { icon: <FaUserShield />, title: "contact.doc_aadhaar_f", desc: "contact.doc_aadhaar_f_sub" },
    { icon: <FaImage />, title: "contact.doc_photo_p", desc: "contact.doc_photo_p_sub" },
    { icon: <FaUser />, title: "contact.doc_photo_g", desc: "contact.doc_photo_g_sub" },
    { icon: <FaFileMedical />, title: "contact.doc_medical", desc: "contact.doc_medical_sub" },
    { icon: <FaFileAlt />, title: "contact.doc_discharge", desc: "contact.doc_discharge_sub" }
  ];

  return (
    <div className="contact_container">
      {/* HEADER */}
      <div className="contact_header">
        <h1>{t('contact.header_title')}</h1>
        <p>
          {t('contact.header_desc_1')} <strong>{t('common.brand_name')}</strong>. 
          {t('contact.header_desc_2')}
        </p>
      </div>

      {/* CONTACT INFO */}
      <section className="contact_info_section">
        <div className="contact_cards">
          <div className="contact_card">
            <FaPhoneAlt className="contact_icon"/>
            <h3>{t('contact.call_us')}</h3>
            <p>+91 7066883322</p>
            <p>+91 7385065015</p>
          </div>

          <div className="contact_card">
            <FaEnvelope className="contact_icon"/>
            <h3>{t('contact.email_us')}</h3>
            <p>manavtaHitaay@gmail.com</p>
          </div>

          <div className="contact_card">
            <FaMapMarkerAlt className="contact_icon"/>
            <h3>{t('contact.visit_us')}</h3>
            <p>{t('contact.address_line1')}</p>
            <p>{t('contact.address_line2')}</p>
          </div>
        </div>
      </section>

      {/* SUPPORT SECTION */}
      <section className="support_section">
        <div className="support_container">
          {/* LEFT: Documents */}
          <div className="support_left">
            <div className="contact_docs_section">
              <h3>{t('contact.docs_title')}</h3>
              <p className="contact_docs_intro">{t('contact.docs_intro')}</p>
              
              <div className="contact_docs_grid">
                {admissionDocs.map((doc, index) => (
                  <div className="contact_doc_card" key={index}>
                    <span className="contact_doc_icon">{doc.icon}</span>
                    <h4>{t(doc.title)}</h4>
                    <p>{t(doc.desc)}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT: Stats & Form */}
          <div className="support_right">
            <div className="support_stats">
              <div className="stat_box">
                <FaHeadset/>
                <h3>24/7</h3>
                <p>{t('contact.stat_support')}</p>
              </div>
              <div className="stat_box">
                <FaBolt/>
                <h3>15min</h3>
                <p>{t('contact.stat_response')}</p>
              </div>
              <div className="stat_box">
                <FaSmile/>
                <h3>98%</h3>
                <p>{t('contact.stat_satisfaction')}</p>
              </div>
            </div>

            <div className="support_form_card">
              <ContactForm showTitle={true}/>
            </div>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="map_section">
        <iframe
          title="Maanavta Hitaay Seva Chatra Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.273295415781!2d73.7663231!3d18.6517178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b9e6e8e8e8e8%3A0x8e8e8e8e8e8e8e8e!2sPradhikaran%2C%20Nigdi%2C%20Pimpri-Chinchwad%2C%20Maharashtra%20411044!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{border:0}}
          loading="lazy"
          allowFullScreen=""
        ></iframe>
      </section>
    </div>
  );
};

export default Contactus;